import { Quill } from 'react-quill'

const Script = Quill.import('formats/script')

// Fixes extra space around sub/sup elements in emails
export class ExtendedScriptBlot extends Script {
  static create(value) {
    const node = super.create(value)
    node.style.lineHeight = '0'
    return node
  }
}
